module.exports = __webpack_public_path__ + "img/play-icon.63caef9b.svg";